import * as React from "react";

function SvgLock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 24.05"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M20.04 12.58v9.83a1.59 1.59 0 01-.48 1.17 1.67 1.67 0 01-1.18.48H1.67a1.66 1.66 0 01-1.18-.48 1.56 1.56 0 01-.45-1.17v-9.83a1.56 1.56 0 01.49-1.17 1.65 1.65 0 011.18-.47h.55V7.66a7.3 7.3 0 012.3-5.4A7.5 7.5 0 0110.04 0a7.54 7.54 0 015.49 2.26 7.29 7.29 0 012.29 5.4v3.28h.56a1.66 1.66 0 011.18.47 1.59 1.59 0 01.48 1.17zM5.56 10.94h8.89V7.66a4.2 4.2 0 00-1.31-3.1 4.31 4.31 0 00-3.1-1.28 4.34 4.34 0 00-3.18 1.28 4.19 4.19 0 00-1.3 3.1z" />
    </svg>
  );
}

const MemoSvgLock = React.memo(SvgLock);
export default MemoSvgLock;
